(() => {
  if (customElements.get('madorne-addon-add')) return;
  class MadorneAddonAdd extends HTMLElement {
    connectedCallback() {
      if (this.ready) {

        document.addEventListener('cart:updated', this.onCart);
        document.addEventListener('cart:refresh', this.onCart);
        document.addEventListener('cart:change', this.onCart);
        this.refreshCart();
        return;
      }
      this.ready = true;
      this.form = this.querySelector('[data-addon-form]');
      this.select = this.querySelector('[data-addon-select]');
      this.button = this.querySelector('[data-addon-button]');
      this.status = this.querySelector('[data-addon-status]');
      this.busy = false;
      this.inCart = false;
      this.baseVariants = JSON.parse(this.querySelector('[data-base-variants]')?.textContent || '[]');
      this.defaultImage = this.querySelector('.madorne-addon__image img')?.src;
      this.onVariant = event => {
        const variant = event.detail?.variant;
        if (!variant) return;
        if (event.detail?.product?.id && String(event.detail.product.id) !== this.dataset.baseProductId) return;
        if (!this.baseVariants.some(item => String(item.id) === String(variant.id))) return;
        this.matchVariant(variant);
      };
      this.onCart = event => {
        if (event.detail?.cart?.items) this.syncCart(event.detail.cart);
        else this.refreshCart();
      };

      document.addEventListener('cart:updated', this.onCart);
      document.addEventListener('cart:refresh', this.onCart);
      document.addEventListener('cart:change', this.onCart);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.add(); });
      this.select.addEventListener('change', () => this.updateVariant());
      this.updateVariant();
      this.refreshCart();
    }
    disconnectedCallback() {

      document.removeEventListener('cart:updated', this.onCart);
      document.removeEventListener('cart:refresh', this.onCart);
      document.removeEventListener('cart:change', this.onCart);
    }
    matchVariant(variant) {
      if (this.busy) return;
      const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s*\/\s*Ottoman$/i, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const finish = normalize(variant.title || variant.options?.join(' / '));
      const matches = Array.from(this.select.options).filter(option => option.value && !option.disabled && normalize(option.dataset.title) === finish);
      this.select.value = matches.length === 1 ? matches[0].value : '';
      this.select.hidden = this.select.options.length === 2 && matches.length === 1;
      this.updateVariant();
      const note = this.querySelector('[data-addon-match]');
      if (note) note.textContent = matches.length === 1 ? 'Matching finish selected.' : 'No exact finish match. Choose the finish you prefer.';
    }
    syncCart(cart) {
      this.inCart = cart.items.some(item => String(item.product_id) === this.dataset.addonProductId);
      this.hidden = this.inCart;
      this.button.disabled = this.inCart || this.busy || !this.select.value || this.select.selectedOptions[0]?.disabled;
    }
    async refreshCart() {
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}});
        if (res.ok) this.syncCart(await res.json());
      } catch (_) { /* Keep the explicit selection available on a read failure. */ }
    }
    updateVariant() {
      const option = this.select.selectedOptions[0];
      if (!option || !option.value) {
        const price = this.querySelector('[data-addon-price]');
        if (price) price.textContent = 'From ' + this.dataset.addonMinPrice;
        const image = this.querySelector('.madorne-addon__image img');
        if (image && this.defaultImage) { image.removeAttribute('srcset'); image.src = this.defaultImage; }
        this.querySelectorAll('[data-addon-link]').forEach(link => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.delete('variant');
          link.href = url.href;
        });
        this.button.disabled = true;
        this.button.textContent = 'Add';
        return;
      }
      this.querySelector('[data-addon-price]').textContent = option.dataset.price;
      this.querySelectorAll('[data-addon-link]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', option.value);
        link.href = url.href;
      });
      const image = this.querySelector('.madorne-addon__image img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      this.status.textContent = '';
      this.button.textContent = 'Add';
      this.button.disabled = option.disabled || this.inCart || this.busy;
    }
    async add() {
      if (this.busy || this.inCart || !this.select.value || this.select.selectedOptions[0]?.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.select.disabled = true;
      this.button.textContent = 'Adding…';
      this.status.textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const current = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
        if (current.ok) {
          this.syncCart(await current.json());
          if (this.inCart) { this.status.textContent = 'Already in your cart.'; return; }
        }
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(this.select.value), quantity: 1}]})
        });
        let result;
        try { result = await res.json(); } catch (_) { throw new Error('Please check your cart before trying again.'); }
        if (!res.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
        const item = result.items?.[0] || result;
        this.button.textContent = 'Added';
        this.status.textContent = 'Added to your cart.';
        this.querySelector('[data-addon-cart]').hidden = false;
        // A refresh failure must never retry an already-successful cart write.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true, detail: {source: 'madorne-addon-add', item}
        }));
        try {
          const cartRes = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
          if (cartRes.ok) {
            const cart = await cartRes.json();
            this.syncCart(cart);
            document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = cart.item_count;});
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true, detail: {cart, source: 'madorne-addon-add'}
            }));
          }
        } catch (_) {}
      } catch (error) {
        this.button.textContent = 'Add';
        this.status.textContent = error.message || 'Unable to add this item. Please try again.';
      } finally {
        this.busy = false;
        this.select.disabled = false;
        this.button.disabled = this.inCart || !this.select.value || this.select.selectedOptions[0]?.disabled;
      }
    }
  }
  customElements.define('madorne-addon-add', MadorneAddonAdd);
  // Keep the editorial carousel in sync without performing any cart writes.
  const hideOwnedCards = cart => {
    if (!cart?.items) return;
    const owned = new Set(cart.items.map(item => String(item.product_id)));
    document.querySelectorAll('[data-pairing-product-id]').forEach(card => {
      card.hidden = owned.has(card.dataset.pairingProductId);
    });
    document.querySelectorAll('[data-madorne-crosssell]').forEach(section => {
      const cards = Array.from(section.querySelectorAll('[data-pairing-product-id]'));
      section.hidden = cards.length > 0 && cards.every(card => card.hidden);
    });
  };
  document.addEventListener('cart:updated', event => hideOwnedCards(event.detail?.cart));
  document.addEventListener('cart:change', event => hideOwnedCards(event.detail?.cart));
  fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}})
    .then(res => res.ok ? res.json() : null).then(hideOwnedCards).catch(() => {});
})();
